import { isAirrorInstance } from '@air/utils-error';

const CLIENT_ERROR_MIN = 400;
const CLIENT_ERROR_MAX = 499;
const MAX_RETRY_COUNT = 3;

/**
 * Retry handler for canvas requests that skips retries on 4xx errors
 * (e.g., 403 Forbidden, 404 Not Found) since they won't resolve on retry.
 */
export const shouldRetryCanvasRequest = (failureCount: number, error: unknown) => {
  if (isAirrorInstance(error) && error.statusCode >= CLIENT_ERROR_MIN && error.statusCode <= CLIENT_ERROR_MAX) {
    return false;
  }

  return failureCount < MAX_RETRY_COUNT;
};
